import { call, put } from 'redux-saga/effects';
import { updateChartOfAccountsCustomRow } from '../api';
import {
  updateChartOfAccountsCustomRowFailure,
  updateChartOfAccountsCustomRowSuccess,
  fetchChartOfAccountsForOrganisationRequest,
} from '../actions';
import { UpdateChartOfAccountsCustomRowRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn, turnDrawerOff } from 'store/app/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundARY-TYPES */
export function* updateChartOfAccountsCustomRowSaga(
  action: UpdateChartOfAccountsCustomRowRequestAction
) {
  try {
    let err: ApiError | null;
    const { organisationId, row } = action.payload;

    const response: ApiResponse = yield call(
      updateChartOfAccountsCustomRow,
      organisationId,
      row
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(updateChartOfAccountsCustomRowSuccess());

    const message: MessageData = {
      title: i18n.t('common.success'),
      description: i18n.t('notifications.account-updated-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));

    // Refresh organisation chart of accounts so UI has the updated row
    yield put(fetchChartOfAccountsForOrganisationRequest(organisationId));

    // Close any edit drawer after successful update (if used inside one)
    yield put(turnDrawerOff());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(updateChartOfAccountsCustomRowFailure());
  }
}

